function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.606 27.315c0 14.437 11.703 26.14 26.14 26.14s26.14-11.703 26.14-26.14-11.703-26.14-26.14-26.14-26.14 11.703-26.14 26.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.746 53.454V1.174m-19.1 43.912c4.77-5.104 11.563-8.293 19.1-8.293 7.537 0 14.329 3.19 19.1 8.293M8.646 9.541c4.77 5.103 11.563 8.293 19.1 8.293 7.537 0 14.329-3.19 19.1-8.293m-19.1-8.367C35.872 7.7 41.148 17.003 41.148 27.318s-5.275 19.61-13.402 26.136m0-52.28C19.62 7.7 14.344 17.003 14.344 27.318s5.275 19.61 13.402 26.136M53.885 27.315H1.605"
}));

var SvgEarth = function SvgEarth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEarth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Earth.ce648ae0.svg";
export { ForwardRef as ReactComponent };